import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "./reduxHooks.ts";
import {useGarageScope} from "./useGarageScope.ts";
import {useAuthorize} from "../components/rights/useAuthorize.ts";
import mailServerService from "../service/mailServerService.ts";
import {healthOf, type MailServerHealth} from "../model/mailServer/MailServer.ts";
import {mailServerHealthActions} from "../reducer/mailServerHealthReducer.ts";

export const useMailServerHealth = (): MailServerHealth =>
    useAppSelector(state => state.mailServerHealth.health);

export const useMailServerHealthWatch = () => {
    const dispatch = useAppDispatch();
    const {canRead} = useAuthorize("MailServer");
    const {type, isGroup, garageNo, garageGroupNo} = useGarageScope();
    const loaded = useAppSelector(state => state.mailServerHealth.loaded);

    useEffect(() => {
        if (loaded || !canRead || type === undefined || type === "admin") {
            return;
        }

        // an answer for the garage support has just left must not show up at the next one (#56913)
        let current = true;
        void (async () => {
            try {
                const active = await mailServerService.getActive(isGroup ? "garage-group" : "garage");
                if (current) dispatch(mailServerHealthActions.setHealth(healthOf(active)));
            } catch {
                if (current) dispatch(mailServerHealthActions.setHealth("UNKNOWN"));
            }
        })();
        return () => { current = false; };
    }, [dispatch, loaded, canRead, type, isGroup, garageNo, garageGroupNo]);
};
